/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-11-26                                                        *
 ******************************************************************************/

export default {
    provide(){
        return{
            setFilteredItems:this.setFilteredItems,
            registerFilteredItemsReceiver: this.registerFilteredItemsReceiver,
        };
    },
    data(){
        return {
            filtered_items_receivers:[],
            filtered_items:[],
            filteredLength:0
        };
    },
    methods:{
        registerFilteredItemsReceiver(component){
            this.filtered_items_receivers.push(component);
        },
        setFilteredItems(filtered_items){
            this.filtered_items = filtered_items;
            this.filteredLength = filtered_items.length;
            this.filtered_items_receivers.forEach((component)=>{
                component.setFilteredItems(filtered_items);
            });
        }
    }
}
